<template>
  <v-card v-if="$store.getters.user">
    <v-card-title>
      <h1 class="display-1">Bienvenido</h1>
    </v-card-title>
    <v-card-text>
      <v-btn @click="$router.push({ path: `/pago` })" v-if="$store.getters.user.roles.includes('PAGO')">Pagos</v-btn>
      <v-btn @click="$router.push({ path: `/liquidacion` })"
        v-if="$store.getters.user.roles.includes('LIQUIDACION')">Liquidacion</v-btn>
      <v-btn @click="$router.push({ path: `/planillas` })"
        v-if="$store.getters.user.roles.includes('PLANILLA')">Planillas</v-btn>
      <v-btn @click="$router.push({ path: `/solicitudesUsuarioWeb` })"
        v-if="$store.getters.user.roles.includes('USUARIOSWEB')">Usuarios WEB</v-btn>
      <v-btn @click="$router.push({ path: `/consultaObras` })"
        v-if="$store.getters.user.roles.includes('CONSULTAOBRAS')">Obras</v-btn>
      <v-btn @click="$router.push({ path: `/macheo` })" v-if="$store.getters.user.roles.includes('MACHEO')">Macheo</v-btn>

      <v-btn @click="$router.push({ path: `/distribucion` })"
        v-if="$store.getters.user.roles.includes('DISTRIBUCION')">DISTRIBUCION</v-btn>

      <v-btn @click="$router.push({ path: `/migracion` })"
        v-if="$store.getters.user.roles.includes('MIGRACION')">MIGRACION</v-btn>

      <v-btn @click="$router.push({ path: `/consultaPersonas` })"
        v-if="$store.getters.user.roles.includes('CONSULTAPERSONAS')">PERSONAS</v-btn>

      <v-btn @click="$router.push({ path: `/consultaOrdenPago` })"
        v-if="$store.getters.user.roles.includes('CONSULTAPERSONAS')">ORDEN PAGO</v-btn>

      <v-btn @click="$router.push({ path: `/consultaPagosGeneracion` })"
        v-if="$store.getters.user.roles.includes('CONSULTAPAGOS')">CONSULTA PAGOS</v-btn>

      <v-btn @click="$router.push({ path: `/bmat` })" v-if="$store.getters.user.roles.includes('BMAT')">BMAT</v-btn>

      <v-btn @click="$router.push({ path: `/bolsa` })" v-if="$store.getters.user.roles.includes('BOLSA')">BOLSA</v-btn>

      <v-btn @click="$router.push({ path: `/rbt` })" v-if="$store.getters.user.roles.includes('RBT')">RBT</v-btn>
      <v-btn @click="$router.push({ path: `/kits` })" v-if="$store.getters.user.roles.includes('KITS')">KITS</v-btn>
      <v-btn @click="$router.push({ path: `/tableroEventos` })"
        v-if="$store.getters.user.roles.includes('EVENTOS_SOCIALES_TABLERO')">TABLERO EVENTOS</v-btn>

      <v-btn @click="$router.push({ path: `/asistenciaSocio` })"
        v-if="$store.getters.user.roles.includes('EVENTOS_SOCIALES')">Asistencia Socio</v-btn>

        <v-btn @click="$router.push({ path: `/cumpleanos` })"
        v-if="$store.getters.user.roles.includes('SOCIAL')">Calendario cumpleaños</v-btn>

        <v-btn @click="$router.push({ path: `/expediente` })"
        v-if="$store.getters.user.roles.includes('SOCIAL')">Expedientes</v-btn>

        <v-btn @click="$router.push({ path: `/censo` })"
        v-if="$store.getters.user.roles.includes('CENSO')">Censo</v-btn>

        <v-btn @click="$router.push({ path: `/crd` })"
        v-if="$store.getters.user.roles.includes('DISTRIBUCION')">CRD</v-btn>

        <v-btn @click="$router.push({ path: `/consultaCrd` })"
        v-if="$store.getters.user.roles.includes('DISTRIBUCION')">CRD Consulta</v-btn>


      <v-btn @click="logout">Salir</v-btn>

      <!-- <v-btn @click="test" v-if="env == 'development'">Test</v-btn> -->
      <v-btn @click="test" v-if="$store.getters.user.username == 'admin'">Test</v-btn>

      <!-- <audio controls ref="audio">
         Your browser does not support the &lt;audio&gt; tag. 
        <source ref="source" src="" type="audio/wav" />
      </audio> -->
    </v-card-text>
  </v-card>
</template>

<script>
 import axios from "axios";

export default {
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
    async test() {
   
      // axios.get('pago/notificacionEmail/3268')

      // axios.get('censo?estado=CENSADO')
      // axios.post('censo/cargar10')

      axios.post('/censo/101/estado',{estado: 'CENSADO'});
      

      // axios.post('reports/exportQueryToExcel',{query: "select * from generaciones where id <=10", fileName: "miarchivo.xlsx", mode: "binario"})
      //   .then(() => {
      //     console.log('res')
      //   }).catch (err => {
      //     console.log('err',err)
      //   });
      
    
      console.log("Test clicked");

    },
  },
  data() {
    return {
      env: process.env.NODE_ENV,
    };
  },
};
</script>
